export const isRootAdmin = ({ tokenParsed = {} }) => {
  return (
    tokenParsed.resource_access?.['360-tours-fe'] &&
    tokenParsed.resource_access['360-tours-fe'].roles.includes('rootAdmin')
  );
};
